export type ParsedPageMd = {
  properties: Record<string, string>;
  body: string;
  csvHref: string | null;
  csvLabel: string | null;
};

const CSV_LINK_RE = /\[([^\]]*)\]\(([^)]+\.csv)\)/i;

export function parseNotionPageMd(text: string): ParsedPageMd {
  const normalized = text.replace(/^\uFEFF/, '');
  const lines = normalized.split(/\r?\n/);
  const properties: Record<string, string> = {};
  let i = 0;

  while (i < lines.length) {
    const line = lines[i]!.trim();
    if (line.startsWith('#')) {
      break;
    }
    if (line.length === 0) {
      i++;
      continue;
    }
    const propMatch = line.match(/^([^:]+):\s*(.*)$/);
    if (propMatch) {
      properties[propMatch[1]!.trim()] = propMatch[2]!.trim();
      i++;
      continue;
    }
    break;
  }

  const body = lines.slice(i).join('\n').trim();
  const csvMatch = body.match(CSV_LINK_RE) ?? normalized.match(CSV_LINK_RE);

  return {
    properties,
    body,
    csvHref: csvMatch?.[2]?.trim() ?? null,
    csvLabel: csvMatch?.[1]?.trim() ?? null,
  };
}
